<mat-drawer-container class="w-full h-screen grid grid-cols-1 md:grid-cols-[250px_minmax(0,calc(100vw-250px))] overflow-x-hidden">
    <mat-drawer #drawer mode="side" [(opened)]="opened" class="bg-side" id="sidenav">
      <app-sidenav></app-sidenav>
    </mat-drawer>
    <mat-drawer-content class="min-w-0 overflow-x-hidden">
      <app-toolbar (toggleSidenav)="drawer.toggle()"></app-toolbar>
      <div [ngClass]="!isMobile ? 'px-5 py-5 flex justify-center' : 'px-2 py-2 flex justify-center'">
        <div class="grow min-w-0 max-w-full">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>